import { Instance } from 'mobx-state-tree';
import { OrderAddressIssueCountsDtoModelBase } from './OrderAddressIssueCountsDtoModel.base';

/* The TypeScript type of an instance of OrderAddressIssueCountsDtoModel */
export interface OrderAddressIssueCountsDtoModelType extends Instance<typeof OrderAddressIssueCountsDtoModel.Type> {}

/* A graphql query fragment builders for OrderAddressIssueCountsDtoModel */
export { selectFromOrderAddressIssueCountsDto, orderAddressIssueCountsDtoModelPrimitives, OrderAddressIssueCountsDtoModelSelector } from './OrderAddressIssueCountsDtoModel.base';

/**
 * OrderAddressIssueCountsDtoModel
 */
export const OrderAddressIssueCountsDtoModel = OrderAddressIssueCountsDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
